/* eslint-disable no-prototype-builtins */
import { useSetState, useRequest, useDeepCompareEffect } from 'ahooks'
import { Form } from 'antd-mobile'
import dayjs from 'dayjs'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React from 'react'

import NewEditForm from '@/components/NewEditForm'
import { useCommonForm } from '@/hooks'
import jobStore from '@/store/components/entryJob'
import { isNumber, checkMonthsDifference } from '@/utils/index'

import HPopup from '../../HYBVant/HPopup'
import './index.less'

const EmploymentTypeData = [
  {
    label: '雇员',
    value: '0'
  }
  // {
  //   label: '保险营销员',
  //   value: '1'
  // },
  // {
  //   label: '证券经纪人',
  //   value: '2'
  // },
  // {
  //   label: '其他',
  //   value: '3'
  // },
  // {
  //   label: '实习学生（全日制学历教育）',
  //   value: '4'
  // }
]
const StatusData = [
  {
    label: '正常（在职）',
    value: '0'
  },
  {
    label: '非正常（离职）',
    value: '1'
  }
]
const TaxCalculationMethodData = [
  {
    label: '正算',
    value: '0'
  },
  {
    label: '反算',
    value: '1'
  }
]
const HealthCertificate: React.FC<any> = ({ staffDetail, visible, onCancel, modalData }) => {
  const {
    runDeleteTaxUserInfos,
    runSaveTaxUserInfos,
    deleteTaxUserInfosLoading,
    saveTaxUserInfosLoading,
    status,
    editItem,
    taxUserInfos
  } = modalData
  const [formIt] = Form.useForm()
  const [{ randomForm, isInvestmentRatio, isaAbnormal, postList, officeList }, setState] =
    useSetState<any>({
      randomForm: null,
      postList: [],
      officeList: [],
      isaAbnormal: false,
      isInvestmentRatio: false
    })
  console.log('status----editItem', status, editItem)
  const onFinish = (fieldValues: any) => {
    if (deleteTaxUserInfosLoading || saveTaxUserInfosLoading) return
    const key = taxUserInfos?.length || 0
    const values_info = {
      ...editItem,
      ...fieldValues,
      ...initData(fieldValues),
      key: status !== 'Add' ? editItem?.key : key
    }
    let transformedArray = []
    if (status !== 'Add') {
      transformedArray = taxUserInfos.map((item: any) =>
        item?.key === editItem?.key ? values_info : item
      )
    } else {
      transformedArray = [...taxUserInfos, values_info]
    }
    runSaveTaxUserInfos(transformedArray)
  }

  useDeepCompareEffect(() => {
    formIt.setFieldsValue(editItem)
    setState({
      isaAbnormal: editItem?.status === '1',
      isInvestmentRatio: ['', null, undefined].includes(editItem.investment_total),
      randomForm: Math.random()
    })
  }, [status, editItem])
  const deleteInfo = () => {
    if (status === 'Edit') {
      const newArray = taxUserInfos?.filter((item: any) => item?.key !== editItem?.key)
      runDeleteTaxUserInfos(newArray)
    }
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }
  const onInitData = (data: any) => {
    setState({
      postList: data || []
    })
  }
  const onInitoOfficeData = (data: any) => {
    setState({
      officeList: data || []
    })
  }
  const onValuesChange = (changedValues: any) => {
    if (changedValues.hasOwnProperty('status')) {
      console.log(changedValues?.status, 'changedValues?.status')
      setState({
        isaAbnormal: changedValues?.status === '1'
      })
    } else if (changedValues.hasOwnProperty('investment_total')) {
      setState({
        isInvestmentRatio: ['', null, undefined].includes(changedValues?.investment_total)
      })
    }
  }
  const option = {
    formInfo: [
      {
        title: '企业信息',
        id: 'base',
        is_show_title: true,
        form_list: [
          {
            name: 'status',
            label: '人员状态',
            required: true,
            type: 'RadioGroup',
            direction: 'horizontal',
            formItemProps: {
              initialValue: '0'
            },
            elementProps: {
              dataList: [
                {
                  label: '正常（在职）',
                  value: '0'
                },
                {
                  label: '非正常（离职）',
                  value: '1'
                }
              ]
            }
          },
          {
            name: 'tax_calculation_method',
            label: '算税方式',
            required: true,
            type: 'RadioGroup',
            direction: 'horizontal',
            formItemProps: {
              initialValue: '0'
            },
            elementProps: {
              dataList: [
                {
                  label: '正算',
                  value: '0'
                },
                {
                  label: '反算',
                  value: '1'
                }
              ]
            }
          },
          {
            label: '企业/税局',
            name: 'office_id',
            required: true,
            placeholder: '请选择',
            example_text: {
              text: '选择后，员工将绑定到该企业/税局进行报税'
            },
            type: 'BigDataSelect',
            url: '/tax/agent/company/offices',
            method: 'post',
            onInitData: onInitoOfficeData,
            style: { width: '100%', height: 32 },
            initArgument: { paged: false, cur_page: 0, page_size: 999, enable_status: 1 },
            fieldItem: {
              label_name: 'company_name',
              label_text: '',
              value_name: 'id'
            }
          },
          {
            label: '任职受雇类型',
            name: 'employment_type',
            type: 'Select',
            showSearch: true,
            optionFilterProp: 'label',
            required: true,
            placeholder: '请选择',
            fieldNames: { value: 'value', label: 'name' },
            options: [
              {
                name: '雇员',
                value: '0'
              }
              // {
              //   name: '保险营销员',
              //   value: '1'
              // },
              // {
              //   name: '证券经纪人',
              //   value: '2'
              // },
              // {
              //   name: '其他',
              //   value: '3'
              // },
              // {
              //   name: '实习学生（全日制学历教育）',
              //   value: '4'
              // }
            ]
          },
          {
            name: 'employment_date',
            label: '受雇日期',
            type: 'DatePicker',
            elementProps: {
              format: 'YYYY-MM-DD',
              placeholder: '请选择'
            },
            required: true
          },
          {
            name: 'leave_date',
            label: '离职日期',
            type: 'DatePicker',
            elementProps: {
              format: 'YYYY-MM-DD',
              placeholder: '请选择'
            },
            required: !!isaAbnormal
          },
          {
            label: '职务',
            name: 'position_id',
            placeholder: '请选择',
            type: 'BigDataSelect',
            url: '/hrm/positions',
            method: 'post',
            onInitData: onInitData,
            style: {
              width: '100%',
              height: 32
            },
            initArgument: {
              paged: false,
              cur_page: 0,
              page_size: 999,
              enable_status: 1
            },
            fieldItem: {
              label_name: 'name',
              label_text: 'code',
              value_name: 'id'
            }
          },
          {
            name: 'subtraction',
            label: '是否扣除减除费用',
            required: false,
            type: 'RadioGroup',
            direction: 'horizontal',
            formItemProps: {
              initialValue: 1
            },
            elementProps: {
              dataList: [
                {
                  label: '是',
                  value: 1
                },
                {
                  label: '否',
                  value: 0
                }
              ]
            }
          },
          {
            name: 'investment_total',
            label: '个人投资总额（元）',
            placeholder: '请输入',
            type: 'InputNumber'
          },
          {
            name: 'investment_ratio',
            label: '个人投资比例(%)',
            placeholder: '请输入',
            type: 'InputNumber',
            formItemProps: {
              disabled: !!isInvestmentRatio
            },
            disabled: !!isInvestmentRatio
          },
          {
            type: 'Textarea',
            name: 'remark',
            label: '备注',
            required: false,
            disabled: false,
            maxLength: 255,
            placeholder: '请输入',
            rows: 4,
            single_line: true,
            single_type: 2
          }
        ]
      }
    ]
  }
  const initData = (info: any) => {
    return {
      status_name: getLabelByValue(StatusData, String(info?.status), 'label', 'value'),
      tax_calculation_method_name: getLabelByValue(
        TaxCalculationMethodData,
        String(info?.tax_calculation_method),
        'label',
        'value'
      ),
      employment_type_name: getLabelByValue(
        EmploymentTypeData,
        info?.employment_type,
        'label',
        'value'
      ),
      subtraction_name: info?.subtraction === 1 ? '是' : '否',
      position_name: getLabelByValue(
        postList,
        String(info?.position_id || staffDetail?.work_map?.hrm_position_id),
        'name',
        'id'
      ),
      office_name: getLabelByValue(officeList, String(info?.office_id), 'company_name', 'id')
    }
  }
  function getLabelByValue(statusData: any, value: any, str: string, valueStr: string) {
    const result = statusData?.find((item: any) => item?.[valueStr] === value)
    return result?.[str] ? result?.[str] : null // 如果没有找到匹配项，则返回 null 或其他默认值
  }
  return (
    <HPopup
      title='个税申报信息'
      hasOk={false}
      className='lg'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      <div className='income-tax-declaration-popup'>
        <NewEditForm
          formInst={formIt}
          formInfo={option?.formInfo ?? []}
          onFinish={onFinish}
          onValuesChange={onValuesChange}
          randomForm={randomForm}
          formButtons={getFormButtons(modalData?.status === 'Edit')}
        />
      </div>
    </HPopup>
  )
}

export default observer(HealthCertificate)
